// pages/HomePage.jsx

import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import SplitSection from "../components/SplitSection";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import TechStack from "../components/TechStack";
import HowItWorks from "../components/HowItWorks";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import CTASection from "../components/CTASection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import CookieBanner from "../components/CookieBanner";
import SEOHead from "../components/SEOHead";
import { DEFAULT_CONTENT } from "../data/defaultContent";

const DRAFT_KEY     = "webstudio_draft";
const PUBLISHED_KEY = "webstudio_published";

function readLS(key, fallback) {
  try {
    const s = localStorage.getItem(key);
    return s ? { ...fallback, ...JSON.parse(s) } : fallback;
  } catch { return fallback; }
}

export default function HomePage({ content: contentProp, dark, setDark, lang, setLang, t, isAdmin }) {
  const [content, setContent] = useState(() => {
    if (contentProp) return contentProp;
    const isDraftPreview = typeof window !== "undefined" && window.location.search.includes("preview=draft");
    const published = readLS(PUBLISHED_KEY, DEFAULT_CONTENT);
    return isDraftPreview ? readLS(DRAFT_KEY, published) : published;
  });

  useEffect(() => {
    if (contentProp) setContent(contentProp);
  }, [contentProp]);

  return (
    <div className={`min-h-screen transition-colors duration-300 ${dark ? "bg-[#0F172A] text-white" : "bg-white text-[#0F172A]"}`}>
      <SEOHead content={content} lang={lang} />
      <Navbar content={content} dark={dark} setDark={setDark} lang={lang} setLang={setLang} t={t} isAdmin={isAdmin} />
      <div className="h-16" />

      <Hero          content={content.hero}         dark={dark} lang={lang} />
      <SplitSection  content={content.splitSection} dark={dark} lang={lang} />
      <Services      content={content.services}     dark={dark} lang={lang} t={t} mobileSwiper={content.servicesMobileSwiper ?? true} />
      <Portfolio     content={content.portfolio}    dark={dark} lang={lang} t={t} hasBg={content.sectionBg?.portfolio ?? false} />
      <HowItWorks    dark={dark} lang={lang} t={t} />
      <TechStack     content={content.techStack}    dark={dark} lang={lang} />
      <Pricing       content={content.pricing}      dark={dark} lang={lang} t={t} hasBg={content.sectionBg?.pricing ?? false} />
      <Testimonials  content={content.testimonials} dark={dark} lang={lang} t={t} />
      <CTASection    content={content.cta}          dark={dark} lang={lang} />
      <Contact       content={content.contact}      dark={dark} lang={lang} t={t} hasBg={content.sectionBg?.contact ?? false} />
      <Footer        content={content.footer}       dark={dark} lang={lang} setLang={setLang} t={t} logo={content.logo} />

      <WhatsAppButton content={content.whatsapp} dark={dark} />
      <CookieBanner dark={dark} />
    </div>
  );
}
